import React, { FunctionComponent } from 'react'
import { TextStyle, View } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { BaseText } from '../../atoms/baseText/BaseText'
import { BodyTextSize, TextType, TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

type SummarySectionProps = {
  trailingHeader?: React.ReactNode
  title?: React.ReactNode
  description?: React.ReactNode
  descriptionStyle?: TextStyle
  children?: React.ReactNode
  testID?: string
  rightSection?: React.ReactNode
  headerHasRowOrientation?: boolean
}

const ChildrenContainer = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  marginTop: spacing['16px'],
}))

const Header = styled.View<{ headerHasRowOrientation: boolean }>(({ theme, headerHasRowOrientation }) => ({
  flexDirection: headerHasRowOrientation ? 'row' : 'column',
  justifyContent: 'space-between',
  gap: theme.spacing['16px'],
}))

const TitleContainer = styled.View({
  flexDirection: 'row',
  justifyContent: 'space-between',
})

export const SummarySection: FunctionComponent<SummarySectionProps> = ({
  title,
  trailingHeader,
  description,
  descriptionStyle,
  children,
  testID,
  rightSection,
  headerHasRowOrientation = false,
}) => {
  const { colors } = useTheme()

  return (
    <View testID={testID}>
      <Header headerHasRowOrientation={headerHasRowOrientation}>
        <View>
          <TitleContainer>
            {title ? <BaseText type={TextType.TITLE} size={TitleSize.MEDIUM} text={title} /> : null}
            {trailingHeader}
          </TitleContainer>
          <BaseText
            testID={tID('description')}
            type={TextType.BODY}
            size={BodyTextSize.DEFAULT}
            color={colors.textSecondary}
            style={descriptionStyle}
            text={description}
          />
        </View>
        {rightSection}
      </Header>
      <ChildrenContainer>{children}</ChildrenContainer>
    </View>
  )
}
